import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { RxChangeAlertsCount } from "../../Apis/AuthApiServices";
import {
  loadingRxChangeAlerts,
  setRxChangeAlerts,
} from "../Slice/RxChangeAlertsSlice";

function* onLoadRxChangeAlertsAsync({ payload }: any) {
  const params = new URLSearchParams();
  let doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  try {
    const result: AxiosResponse = yield RxChangeAlertsCount(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setRxChangeAlerts({
          RxChangeAlertsData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setRxChangeAlerts({
          RxChangeAlertsData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setRxChangeAlerts({
        RxChangeAlertsData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadRxChangeAlerts() {
  yield takeLatest(loadingRxChangeAlerts.type, onLoadRxChangeAlertsAsync);
}

const RxChangeAlertsSaga = [fork(onLoadRxChangeAlerts)];
export default RxChangeAlertsSaga;
